import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import Dexie from 'dexie'
import db from './components/db'
import Home from './pages/Home'
import About from './pages/About'
import Search from './pages/Search'
import SearchTerm from './pages/SearchTerm'
import Settings from './pages/Settings'

class App extends Component {
  constructor() {
    super()
    this.state = {
      loading: true,
      useDB: false,
      hideDeleteModal: true,
      deleteSearchId: '',
      deleteSearchIndex: '',
      deleteResultIndex: '',
      currentSearch: '',
      searches: []
    }
    this.addSearchTerm = this.addSearchTerm.bind(this)
    this.updateSearchTerm = this.updateSearchTerm.bind(this)
    this.deleteSearchTerm = this.deleteSearchTerm.bind(this)
    this.addSearchResult = this.addSearchResult.bind(this)
    this.deleteSearchResult = this.deleteSearchResult.bind(this)
    this.confirmDeleteSearchResult = this.confirmDeleteSearchResult.bind(this)
    this.confirmDeleteSearchItem = this.confirmDeleteSearchItem.bind(this)
    this.updateSearchResult = this.updateSearchResult.bind(this)
    this.updateSearch = this.updateSearch.bind(this)
    this.updateResultOrder = this.updateResultOrder.bind(this)
    this.overwriteSearches = this.overwriteSearches.bind(this)
    this.closeDeleteModal = this.closeDeleteModal.bind(this)
    this.doSearch = this.doSearch.bind(this)
  }
  componentDidMount() {
    const someIndexedDB = window.indexedDB ||
    window.mozIndexedDB ||
    window.webkitIndexedDB ||
    window.msIndexedDB

    if (someIndexedDB) {
      this.useDB = true
      this.initSearchData()
      console.log("IndexedDB is supported.");
    }
  }
  initSearchData() {
    db.table('searches')
    .toArray()
    .then((searches) => {
      this.setState({ 
        searches,
        loading: false
      })
    })
  }
  addSearchTerm(term) {
    let searches = this.state.searches.slice(0)
    searches.push(term)
    this.setState({searches})
    if (this.useDB) {
      db.searches
      .add(term)
    }
  }
  updateSearchTerm(searchTerm, id) {
    const searches = this.state.searches.slice(0)
    for (let i = 0; i < searches.length; i++) {
      if (id === searches[i].id) {
        searches[i].searchTerm = searchTerm
      }
    }
    this.setState({searches})
    if (this.useDB) {
      db.searches
      .update(id, { searchTerm })
    }
  }
  deleteSearchTerm(id) {
    this.setState({
      hideDeleteModal: false,
      deleteSearchId: id
    })
  }
  confirmDeleteSearchTerm() {
    const searches = this.state.searches.slice(0)
    const deleteSearchId = this.state.deleteSearchId
    for (let i = 0; i < searches.length; i++) {
      if (this.state.deleteSearchId === searches[i].id) {
        searches.splice(i, 1)
        this.setState({
          searches: searches,
          hideDeleteModal: true,
          deleteSearchId: ''
        })
      }
    }
    this.setState({searches})
    if (this.useDB) {
      db.searches
      .delete(deleteSearchId)
    }
  }
  addSearchResult(id, result) {
    const searches = this.state.searches.slice(0)
    for (let i = 0; i < searches.length; i++) {
      if (id === searches[i].id) {
        searches[i].results.push(result)
      }
    }
    this.setState({searches})
    if (this.useDB) {
      db.searches.where('id').equals(id).modify(
        search => search.results.push(result) 
      )
    }
  }
  deleteSearchResult(searchId, resultIndex) {
    this.setState({
      hideDeleteModal: false,
      deleteSearchId: searchId,
      deleteResultIndex: resultIndex
    })
  }
  confirmDeleteSearchResult() {
    const searches = this.state.searches.slice(0)
    const deleteSearchId = this.state.deleteSearchId
    const resultIndex = this.state.deleteResultIndex
    for (let i = 0; i < searches.length; i++) {
      if (deleteSearchId === searches[i].id) {
        searches[i].results.splice(resultIndex, 1)
      }
    }
    this.setState({
      searches,
      hideDeleteModal: true,
      deleteSearchId: '',
      deleteResultIndex: ''
    })
    if (this.useDB) {
      db.searches.where('id').equals(deleteSearchId).modify(
        search => search.results.splice(resultIndex, 1) 
      )
    }
  }
  confirmDeleteSearchItem() {
    if (this.state.deleteResultIndex !== '') {
      this.confirmDeleteSearchResult()
    } else {
      this.confirmDeleteSearchTerm()
    }
  }
  updateSearchResult(id, resultIndex, updatedResult) {
    const searches = this.state.searches.slice(0)
    for (let i = 0; i < searches.length; i++) {
      if (id === searches[i].id) {
        searches[i].results[resultIndex] = updatedResult
      }
    }
    
    this.setState({searches})
    if (this.useDB) {
      db.searches.where('id').equals(id).modify(
        search => search.results[resultIndex] = updatedResult 
      )
    }
  }
  /* TODO: Move to utility file. */
  moveArrayElement(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length
        while ((k--) + 1) {
            arr.push(undefined)
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
  }
  updateResultOrder(newIndex, searchIndex, resultIndex) {
    const searches = this.state.searches.slice(0)
    const searchId = searches[searchIndex].id
    const newResults = this.moveArrayElement(searches[searchIndex].results, resultIndex, newIndex)
    this.setState({searches})
    if (this.useDB) {
      db.searches.where('id').equals(searchId).modify(
        search => search.results = newResults 
      )
    }
  }
  overwriteSearches(searches) {
    this.setState({searches})
    if (this.useDB) {
      db.searches.clear()
      .then( () => {
        db.searches.bulkPut(searches).then((lastKey) => {
          console.log("All searches were added.")
          console.log("Last search id was: ", lastKey)
        }).catch(Dexie.BulkError, (e) => {
            console.error ('Number of failed searches: ', e.failures.length)
        })
      })
    }
  }
  closeDeleteModal() {
    this.setState({
      hideDeleteModal: true,
      deleteSearchIndex: '',
      deleteResultIndex: ''  
    })
  }
  updateSearch(event) {
    this.setState({ currentSearch: event.target.value})
  }
  doSearch(event) {
    event.preventDefault()
    this.context.router.history.push(`/search?q=` + this.state.currentSearch)
  }
  render() {
    return (
      <Switch>
        <Route exact path='/' render={(props) =>(
          <Home 
            currentSearch={this.state.currentSearch} 
            updateSearch={this.updateSearch} 
            doSearch={this.doSearch} />
        )} />
        <Redirect from="/index.html" to="/" />
        <Route path='/about' component={About} />
        <Route path='/search' render={(props) =>(
          <Search 
            currentSearch={this.state.currentSearch} 
            searches={this.state.searches} 
            updateSearch={this.updateSearch} 
            doSearch={this.doSearch} />
        )} />
        <Route exact path='/settings' render={(props) =>(
          <Settings 
            searches={this.state.searches} 
            loading={this.state.loading} 
            addSearchTerm={this.addSearchTerm}
            deleteSearchTerm={this.deleteSearchTerm}
            overwriteSearches = {this.overwriteSearches}
            closeDeleteModal={this.closeDeleteModal}
            confirmDeleteSearchItem={this.confirmDeleteSearchItem}
            hideDeleteModal={this.state.hideDeleteModal} />
        )} />
        <Route path='/settings/:searchid' render={(props) =>(
          <SearchTerm 
            searches={this.state.searches} 
            loading={this.state.loading} 
            match={props.match} 
            updateSearchTerm={this.updateSearchTerm} 
            addSearchResult={this.addSearchResult} 
            deleteSearchResult={this.deleteSearchResult}
            updateSearchResult={this.updateSearchResult}
            updateResultOrder={this.updateResultOrder}
            closeDeleteModal={this.closeDeleteModal}
            confirmDeleteSearchItem={this.confirmDeleteSearchItem}
            hideDeleteModal={this.state.hideDeleteModal} />
        )} />
      </Switch>
    )
  }
}

App.contextTypes = {
  router: PropTypes.object
}

export default App



// WEBPACK FOOTER //
// ./src/App.js